import React from "react"
import mount from "core/mount"
import Note from "@kit/design/note"
import { TrialRing, useTrialProgress } from "@kit/design/trial-indicator"
import { Button } from "@kit/design/button"
import { useMediaBreakpoint } from "@kit/design/use-media-breakpoint"
import { analytics } from "utils/analytics"

export function TrialUpgradeBanner({ daysRemaining, daysTotal }) {
  const isDesktop = useMediaBreakpoint("md")
  const { safeDaysRemaining, progress, dayLabel } = useTrialProgress(
    daysRemaining ?? 0,
    daysTotal ?? 0
  )

  if (!isDesktop) return null

  function handleUpgradeClick() {
    analytics.track(
      "Element",
      "Clicked",
      {
        element_type: "button",
        text: "Upgrade now",
        location: "trial_upgrade_banner"
      },
      { transport: "beacon" }
    )
    window.location.href = "/upgrade"
  }

  return (
    <Note type="info" size="sm" icon={false}>
      <TrialRing progress={progress} />
      <p className="grow ml-4">
        <strong>
          {safeDaysRemaining} {dayLabel} left on your free trial
        </strong>{" "}
        Upgrade to continue to use all the features you have access to without
        interruption.
      </p>
      <Button
        variant="brand"
        size="small"
        onClick={handleUpgradeClick}
        className="ml-4"
      >
        Upgrade now
      </Button>
    </Note>
  )
}

mount({ "Layout.TrialUpgradeBanner": TrialUpgradeBanner })
